// extracted by mini-css-extract-plugin
module.exports = {"header":"chart-header_header__G4l3Y","title":"chart-header_title__1Y26L","subTitle":"chart-header_subTitle__2P2PV"};